<!--
 * @Author: qx
 * @Date: 2022-10-25 09:12:58
 * @LastEditTime: 2022-11-01 10:34:01
 * @LastEditors: qx
 * @Description: 申请授权
-->
<template>
  <div class="container">
    <el-breadcrumb separator="/" style="line-height: 40px">
      <el-breadcrumb-item to="/ecologicalCooperation">合作伙伴</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="tip">
      <el-button class="but" type="primary" @click="routeHandle">我知道了>> </el-button>
      <span class="count-show">{{count ? `${count}S` : ''}}</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      count: 0
    }
  },
  created () {
    this.count = 10
    this.timer()
  },
  methods: {
    // 60S倒计时
    timer () {
      if (this.count > 0) {
        this.count--
        this.$nextTick(() => {
          setTimeout(this.timer, 1000)
        })
      } else {
        this.count = 0
        this.routeHandle()
      }
    },
    routeHandle () {
      this.$router.push({
        name: 'ecologicalCooperationAdd'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tip{
  width: 100%;
  height: 670px;
  background-size: 100% 100%;
  background-image: url(~@/assets/img/ecologicalCooperation/requirement.png);
  position: relative;
  text-align: center;
  .but{
    position: absolute;
    bottom: 20px;
    right: 20px;
  }
  .count-show{
    position: absolute;
    bottom: 20px;
    left: 49%;
    color: #fff;
    font-weight: bold;
    line-height: 40px;
  }
}
</style>
